import React from 'react';
import isEqual from 'lodash/isEqual';
import findIndex from 'lodash/findIndex';
import classNames from 'classnames';

const MAX_ITEMS = 3;

class ColorPalette extends React.Component {
  clickHandler(value) {
    const currentValues = this.props.input.value || [];
    const valueIndex = findIndex(currentValues, v => isEqual(v, value));
    if (valueIndex >= 0) {
      this.props.input.onChange(currentValues.filter((v, i) => i !== valueIndex));
    } else if (currentValues.length < MAX_ITEMS){
      this.props.input.onChange(currentValues.concat([value]));
    }
  }

  render() {
    const { input, item } = this.props;
    const selected = findIndex(input.value, v => isEqual(v, item.colors)) >= 0;
    const swatchStyles = [
      { backgroundColor: '#' + item.colors[0] },
      { backgroundColor: '#' + item.colors[1] },
      { backgroundColor: '#' + item.colors[2] },
      { backgroundColor: '#' + item.colors[3] },
      { backgroundColor: '#' + item.colors[4] },
      { backgroundColor: '#' + item.colors[5] },
      { backgroundColor: '#' + item.colors[6] },
      { backgroundColor: '#' + item.colors[7] },
      { backgroundColor: '#' + item.colors[8] }
    ];

    return (
      <div className="columns small-8 large-5" onClick={this.clickHandler.bind(this, item.colors)}>
        <div className={classNames('tile', {'selected' : selected})}>
          <div className="color-block" style={swatchStyles[0]}/>
          <div className="color-block" style={swatchStyles[1]}/>
          <div className="color-block" style={swatchStyles[2]}/>
          <div className="color-block" style={swatchStyles[3]}/>
          <div className="color-block" style={swatchStyles[4]}/>
          <div className="color-block" style={swatchStyles[5]}/>
          <div className="color-block" style={swatchStyles[6]}/>
          <div className="color-block" style={swatchStyles[7]}/>
          <div className="color-block" style={swatchStyles[8]}/>
          <div className="clearfix"/>
          <h4>{item.label}</h4>
        </div>
      </div>
    );
  }
}

class ColorPaletteSelectorInput extends React.Component {


  render (){
    const { input, name, stepTitle, stepDescription, stepHelp, stepNumber, stepCount} = this.props;
      return (
        <div className="color-choices">
          <div className="row" key={name}>
            { this.props.options.map((itemData, i) => (
            <ColorPalette key={i} item={itemData} input={this.props.input} meta={ this.props.meta } />
            ))}
          </div>
        </div>
      )
  }

};


export default ColorPaletteSelectorInput



// WEBPACK FOOTER //
// ./pap/components/common/input_fields/color_selector.jsx